import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.less';
import qiye from '../../public/images/qiye.png';
import geren from '../../public/images/geren.png';
import { getCustom } from '../../service/chat-service';

const propTypes = {
  history: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  history: [],
};

/**
 * 选择角色
 */
export class selectrole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      obj: {},
      company: false,
      personal: false,
    };
  }

  componentDidMount() {
    this.getCustom();
    window.document.title = '选择角色';
  }

  // 路由跳转
  router = (id) => {
    const { history } = this.props;
    const url = window.location.search.split('?')[1].split('&');
    const obj = {};
    url.forEach((item) => {
      // eslint-disable-next-line prefer-destructuring
      obj[item.split('=')[0]] = item.split('=')[1];
    });

    const urlSearch = `staffUserId=${obj.staffUserId || ''}&companyCode=${obj.companyCode || ''}`;

    if (id === 1) {
      history.push(`/personageEnroll?${urlSearch}`);
    } else {
      history.push(`/enterpriseEnroll?${urlSearch}`);
    }
  };

  // 查询 企业自定义h5链接
  getCustom = () => {
    const url = window.location.search.split('?')[1].split('&');
    const obj = {};
    url.forEach((item) => {
      // eslint-disable-next-line prefer-destructuring
      obj[item.split('=')[0]] = item.split('=')[1];
    });
    getCustom(obj).then((data) => {
      let { isEnableH5RegisterCompany, isEnableH5RegisterPersonal } = data;
      isEnableH5RegisterCompany = isEnableH5RegisterCompany === 1;
      isEnableH5RegisterPersonal = isEnableH5RegisterPersonal === 1;
      this.setState({
        company: isEnableH5RegisterCompany,
        personal: isEnableH5RegisterPersonal,
        obj: data,
      }, () => {
        const { company, personal } = this.state;
        // 如果只有个人一种身份，直接跳转
        if (personal && !company) {
          this.router(1);
        }
      });
    });
  };

  renderModel() {
    const { company, personal } = this.state;
    return (
      <div className={styles.box}>
        <div className={styles.con}>
          <div className={styles.boxfff}>
            {personal
            && (
            <div className={styles.div1} onClick={this.router.bind(null, 1)} role="button" tabIndex={0}>
              <div className={styles.imgs}>
                <img className={styles.gerens} src={geren} alt="" />
              </div>
              <div>
                <span>注册成为个人兼职渠道</span>
              </div>
            </div>
            )}
            {company
            && (
            <div className={styles.div1} onClick={this.router.bind(null, 2)} role="button" tabIndex={0}>
              <div className={styles.imgs}>
                <img src={qiye} alt="" />
              </div>
              <div>
                <span>注册成为渠道公司</span>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderIframe() {
    const { company, personal, obj } = this.state;
    const { url } = obj;
    return (
      <div>
        <iframe title="分享链接" className={styles.ifame} src={url} />
        <div className={styles.button}>
          {personal
          && <button onClick={this.router.bind(null, 1)} className={styles.btu} type="button"> 注册成为个人渠道</button>}
          {company
          && <button onClick={this.router.bind(null, 2)} className={styles.btu} type="button"> 注册成为渠道公司</button>}
        </div>
      </div>
    );
  }

  render() {
    const { obj } = this.state;
    const { isEnable } = obj;
    return (
      <div>
        {
          isEnable === 1 ? this.renderIframe() : this.renderModel()
        }
      </div>
    );
  }
}

selectrole.propTypes = propTypes;
selectrole.defaultProps = defaultProps;

export default selectrole;
